import { render, staticRenderFns } from "./contact-import-preview-table.vue?vue&type=template&id=2ca025e2&scoped=true&"
import script from "./contact-import-preview-table.vue?vue&type=script&lang=js&"
export * from "./contact-import-preview-table.vue?vue&type=script&lang=js&"
import style0 from "./contact-import-preview-table.vue?vue&type=style&index=0&id=2ca025e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca025e2",
  null
  
)

export default component.exports